import React, { Component } from "react";
export const intelliegenceContext = React.createContext();

const date = new Date();
date.setUTCHours(0, 0, 0, 0);
date.setDate(date.getDate() - 2);

class intelliegenceContextProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
      mapRef: null,
      zoomLevel: 3,
      location: '',
      messageToast: {
        status: false,
        message: "",
      },
      commodotieFilter: false,
      markerLocation: [],
      mapLocation: {
        lng: 35.5994,
        lat: 20.6731,
      },
      mapMount: false,
      notificationMessage:
        "Please select any location or supplier to see the data",
      loader: false,
      markerPayload: {
        location: "",
        location_type: "",
        category: "all",
        start_date: date.toISOString().split(".")[0],
        end_date: new Date().toISOString().split(".")[0],
        supplier_id: "",
        commodity: [],
      },
      drawer: {
        filter: false,
        news: true,
      },
      activeMarkerId: null,
      timeWindowLabel: 'Today',
      coordinates: [],
      setmessageToast: this.setmessageToast,
      setLocation: this.setLocation,
      setInfoWindowIsShow: this.setInfoWindowIsShow,
      setCommodotieFilter: this.setCommodotieFilter,
      setMarkerLocation: this.setMarkerLocation,
      setMapLocation: this.setMapLocation,
      setMapRef: this.setMapRef,
      setZoomLevel: this.setZoomLevel,
      setMapMount: this.setMapMount,
      setMarkerPayload: this.setMarkerPayload,
      setLoaderStatus: this.setLoaderStatus,
      setNotificationMessage: this.setNotificationMessage,
      setDrawer: this.setDrawer,
      setActiveMarkerId: this.setActiveMarkerId,
      setTimeWindowLabel: this.setTimeWindowLabel,
      setCoordinates: this.setCoordinates
    };
  }

  setmessageToast = (messageToast) => {
    this.setState({ messageToast });
  };

  setLocation = (location) => {
    this.setState({ location });
  }

  setInfoWindowIsShow = (infoWindowIsShow) => {
    this.setState({ infoWindowIsShow });
  };

  setCommodotieFilter = (commodotieFilter) => {
    this.setState({ commodotieFilter });
  };

  setMarkerLocation = (markerLocation) => {
    this.setState({ markerLocation });
  };

  setMapLocation = (mapLocation) => {
    this.setState({ mapLocation });
  };

  setMapRef = (mapRef) => {
    this.setState(mapRef);
  };

  setZoomLevel = (zoomLevel) => {
    this.setState({ zoomLevel });
  };

  setMapMount = (mapMount) => {
    this.setState({ mapMount });
  };

  setMarkerPayload = (markerPayload) => {
    this.setState({ markerPayload });
  };

  setLoaderStatus = (loader) => {
    this.setState({ loader });
  };

  setNotificationMessage = (notificationMessage) => {
    this.setState({ notificationMessage });
  };

  setDrawer = (drawer) => {
    this.setState({ drawer });
  };

  setActiveMarkerId = (activeMarkerId) => {
    this.setState({ activeMarkerId });
  };

  setTimeWindowLabel = (timeWindowLabel) => {
    this.setState({ timeWindowLabel });
  }

  setCoordinates = (coordinates) => {
    this.setState({ coordinates });
  }

  render() {
    return (
      <intelliegenceContext.Provider value={this.state}>
        {this.state.children}
      </intelliegenceContext.Provider>
    );
  }
}

export default intelliegenceContextProvider;
